// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_feedHeader__HpzfM {
  display: grid;
  grid-template-columns: 120px 140px 160px 1fr 140px;
  gap: 16px;
  padding: 16px 20px;
  background: #f8f9fa;
  border-radius: 8px 8px 0 0;
  border: 1px solid #e9ecef;
  border-bottom: 2px solid #dee2e6;
  margin-bottom: 8px; }
  .styles_feedHeader__HpzfM .styles_headerCell__v7QxF {
    font-weight: 600;
    font-size: 13px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: #495057; }

.styles_feedItem__OTGtX {
  display: grid;
  grid-template-columns: 120px 140px 160px 1fr 140px;
  gap: 16px;
  padding: 20px;
  background: white;
  border-radius: 8px;
  border: 1px solid #e9ecef;
  margin-bottom: 12px;
  transition: all 0.2s ease;
  align-items: center; }
  .styles_feedItem__OTGtX:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    border-color: #dee2e6;
    transform: translateY(-1px); }
  .styles_feedItem__OTGtX .styles_amount__od1Kr {
    font-weight: 600;
    font-size: 18px;
    color: #28a745; }
  .styles_feedItem__OTGtX .styles_date__segGF {
    color: #6c757d;
    font-size: 14px; }
  .styles_feedItem__OTGtX .styles_externalId__OdfHo {
    font-family: 'Monaco', 'Courier New', monospace;
    font-size: 13px;
    color: #495057;
    background: #f8f9fa;
    padding: 4px 8px;
    border-radius: 4px;
    display: inline-block; }
  .styles_feedItem__OTGtX .styles_user__Vl5cn {
    color: #212529;
    font-size: 15px;
    font-weight: 500; }
  .styles_feedItem__OTGtX .styles_receiptLink__oR03h {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 8px 16px;
    background: #007bff;
    color: white !important;
    text-decoration: none !important;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.2s ease; }
    .styles_feedItem__OTGtX .styles_receiptLink__oR03h:hover {
      background: #0056b3;
      transform: scale(1.02); }
    .styles_feedItem__OTGtX .styles_receiptLink__oR03h:active {
      transform: scale(0.98); }

.styles_feedContainer__sZyub .styles_emptyState__Y6fSq {
  padding: 40px;
  text-align: center;
  color: #6c757d;
  font-size: 16px; }
`, "",{"version":3,"sources":["webpack://./src/modules/membership/components/PaymentsFeed/styles.module.scss"],"names":[],"mappings":"AAAA;EACI,aAAa;EACb,kDAAkD;EAClD,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;EAC1B,yBAAyB;EACzB,gCAAgC;EAChC,kBAAkB,EAAA;EATtB;IAYQ,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,qBAAqB;IACrB,cAAc,EAAA;;AAItB;EACI,aAAa;EACb,kDAAkD;EAClD,SAAS;EACT,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB,EAAA;EAVvB;IAaQ,yCAAyC;IACzC,qBAAqB;IACrB,2BAA2B,EAAA;EAfnC;IAmBQ,gBAAgB;IAChB,eAAe;IACf,cAAc,EAAA;EArBtB;IAyBQ,cAAc;IACd,eAAe,EAAA;EA1BvB;IA8BQ,+CAA+C;IAC/C,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB,EAAA;EApC7B;IAwCQ,cAAc;IACd,eAAe;IACf,gBAAgB,EAAA;EA1CxB;IA8CQ,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,mBAAmB;IACnB,uBAAuB;IACvB,gCAAgC;IAChC,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,yBAAyB,EAAA;IAxDjC;MA2DY,mBAAmB;MACnB,sBAAsB,EAAA;IA5DlC;MAgEY,sBAAsB,EAAA;;AAKlC;EAEQ,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,eAAe,EAAA","sourcesContent":[".feedHeader {\n    display: grid;\n    grid-template-columns: 120px 140px 160px 1fr 140px;\n    gap: 16px;\n    padding: 16px 20px;\n    background: #f8f9fa;\n    border-radius: 8px 8px 0 0;\n    border: 1px solid #e9ecef;\n    border-bottom: 2px solid #dee2e6;\n    margin-bottom: 8px;\n\n    .headerCell {\n        font-weight: 600;\n        font-size: 13px;\n        text-transform: uppercase;\n        letter-spacing: 0.5px;\n        color: #495057;\n    }\n}\n\n.feedItem {\n    display: grid;\n    grid-template-columns: 120px 140px 160px 1fr 140px;\n    gap: 16px;\n    padding: 20px;\n    background: white;\n    border-radius: 8px;\n    border: 1px solid #e9ecef;\n    margin-bottom: 12px;\n    transition: all 0.2s ease;\n    align-items: center;\n\n    &:hover {\n        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n        border-color: #dee2e6;\n        transform: translateY(-1px);\n    }\n\n    .amount {\n        font-weight: 600;\n        font-size: 18px;\n        color: #28a745;\n    }\n\n    .date {\n        color: #6c757d;\n        font-size: 14px;\n    }\n\n    .externalId {\n        font-family: 'Monaco', 'Courier New', monospace;\n        font-size: 13px;\n        color: #495057;\n        background: #f8f9fa;\n        padding: 4px 8px;\n        border-radius: 4px;\n        display: inline-block;\n    }\n\n    .user {\n        color: #212529;\n        font-size: 15px;\n        font-weight: 500;\n    }\n\n    .receiptLink {\n        display: inline-flex;\n        align-items: center;\n        justify-content: center;\n        padding: 8px 16px;\n        background: #007bff;\n        color: white !important;\n        text-decoration: none !important;\n        border-radius: 6px;\n        font-size: 14px;\n        font-weight: 500;\n        transition: all 0.2s ease;\n\n        &:hover {\n            background: #0056b3;\n            transform: scale(1.02);\n        }\n\n        &:active {\n            transform: scale(0.98);\n        }\n    }\n}\n\n.feedContainer {\n    .emptyState {\n        padding: 40px;\n        text-align: center;\n        color: #6c757d;\n        font-size: 16px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"feedHeader": `styles_feedHeader__HpzfM`,
	"headerCell": `styles_headerCell__v7QxF`,
	"feedItem": `styles_feedItem__OTGtX`,
	"amount": `styles_amount__od1Kr`,
	"date": `styles_date__segGF`,
	"externalId": `styles_externalId__OdfHo`,
	"user": `styles_user__Vl5cn`,
	"receiptLink": `styles_receiptLink__oR03h`,
	"feedContainer": `styles_feedContainer__sZyub`,
	"emptyState": `styles_emptyState__Y6fSq`
};
export default ___CSS_LOADER_EXPORT___;
